import { ReactElement } from "react";
import { OptionType, Term } from "./tag-input-with-autocomplete.types";

export function isOfStringType(arg: string[] | Term[]): boolean {
  let isString = true;
  arg.forEach(function (item) {
    if (typeof item !== "string") {
      // if Term[] type, string is false
      isString = false;
    }
  });
  return isString && arg.length > 0;
}

/**
 * Split out matching characters into array with non matching characters
 * ex: Search term "am", transformItem takes "American Samoa" and returns it as ["am", erican S", "am", "oa"]
 * to eventually be wrap matching search value characters with <mark> text to style
 */
export const transformItem = (item: string, matchKey: string): string[] => {
  const formatItem: string[] = [];
  let index,
    pos = 0;

  const matchItemCase = item.toLowerCase();
  const matchKeyCase = matchKey.toLowerCase();

  while (matchItemCase.indexOf(matchKeyCase, pos) >= 0) {
    // there's a match
    index = matchItemCase.indexOf(matchKeyCase, pos);
    // put everything preceding matching term and matching term in array, respectively
    if (pos !== index) {
      formatItem.push(item.substring(index, pos));
      formatItem.push(item.substring(index, index + matchKey.length));
    } else if (pos === index) {
      // when the first result of the starting index is a match ie, "g" or "gu" (guatemala)
      formatItem.push(item.substring(pos, index + matchKey.length));
    }
    pos = index + matchKey.length;
  }

  // captures the remaining part of the string that has no matches
  if (pos < item.length) {
    formatItem.push(item.substring(pos));
  }
  return formatItem;
};

/**
 * Extract key and value props from `item` object to pass into trasnformItem util,
 * which only takes string values
 */
export const handleTransformTerm = (
  item: Term,
  matchKey: string
): OptionType => {
  const termItem: OptionType = {
    value: [],
    key: [],
  };

  for (const prop in item) {
    // extracting the value if item.key is a ReactNode
    let extractItem;
    if (typeof item[prop] === "object") {
      extractItem = (item[prop] as ReactElement)?.props?.children;
    } else {
      extractItem = item[prop];
    }
    if (prop !== "metadata") {
      termItem[prop as keyof OptionType] = transformItem(extractItem, matchKey);
    } else {
      termItem[prop as keyof OptionType] = item[prop];
    }
  }
  return termItem;
};
